import { defaultChatInitializeTypes, driverChatInitializeTypes } from "helpers/enums";
import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";

const config = {
    driverChatInitializeType: {
        // field
        label: "Список участников чата с водителем при его создании",
        inputProps: { name: "driverChatInitializeType" },
        options: driverChatInitializeTypes,
        required: true,
        validators: [requiredField],
    },
    defaultChatInitializeType: {
        // field
        label: "Список участников чата с уведомлениями при его создании",
        inputProps: { name: "defaultChatInitializeType" },
        options: defaultChatInitializeTypes,
        required: true,
        validators: [requiredField],
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
